import RejectState from './RejectState';

export default RejectState;
